(function ($, Global) {
    var MESSAGE_COOKIE_NAME = "_IWH";
    var MessageCookiesComponent = function () {
        this.selector = '.message-cookies';
        this.$el = $(this.selector);
    };

    MessageCookiesComponent.prototype.initEvents = function () {
        this.publishers();
        this.subscribers();
    };

    MessageCookiesComponent.prototype.publishers = function () {
        var self = this;

        $(document).ready(function () {
            var cookieVal = Global.Cookie.get(MESSAGE_COOKIE_NAME);

            if (self.$el.exists() && self.$el.hasClass('in') && cookieVal === 'yes') {
                $.Topic('message-cookie-hide').publish();
            }
        });

        $(document).on('click', self.selector + ' .close', function () {
            $.Topic('message-cookie-hide').publish();
        });
    };

    MessageCookiesComponent.prototype.subscribers = function () {
        var self = this;

        $.Topic('message-cookie-hide').subscribe(function () {
            self.$el.removeClass('in');
        });
    };

    Global.MessageCookiesComponent = MessageCookiesComponent;
}(jQuery, window));